// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__xkZn-","bigColWidth":"Table_bigColWidth__15dLB","biggerColWidth":"Table_biggerColWidth__2RX7s","row":"Table_row__1ncHH","col":"Table_col__rMyZu"};